import { FC, ReactNode, useEffect } from 'react';

import { useTenantTheme } from '../hooks/use-tenant-theme';

import { useTenant } from '@/features/tenant/public';
import { logger } from '@/lib/logger';

export const TenantThemeWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const {
    tenant: { branding },
  } = useTenant();

  useTenantTheme(branding);

  useEffect(() => {
    document.title = branding.appName;
  }, [branding.appName]);

  useEffect(() => {
    logger.debug('tenant theme applied', {
      appName: branding.appName,
      hasCustomFont: Boolean(branding.fontsCssUrl),
      hasLogo: Boolean(branding.logoSymbol || branding.logoText),
      hasBackgroundImage: Boolean(branding.backgroundImage),
    });
  }, [branding]);

  return <>{children}</>;
};
